export var isFunction = function (x) { return typeof x === "function"; };
//# sourceMappingURL=IsFunction.js.map